var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1972_6487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.45 3H9.55C8.14219 3 7 4.0918 7 5.4375V26.5625C7 27.9082 8.14219 29 9.55 29H21.45C22.8578 29 24 27.9082 24 26.5625V5.4375C24 4.0918 22.8578 3 21.45 3ZM15.5 27.375C14.5597 27.375 13.8 26.6488 13.8 25.75C13.8 24.8512 14.5597 24.125 15.5 24.125C16.4403 24.125 17.2 24.8512 17.2 25.75C17.2 26.6488 16.4403 27.375 15.5 27.375ZM21.45 21.8906C21.45 22.2258 21.1631 22.5 20.8125 22.5H10.1875C9.83688 22.5 9.55 22.2258 9.55 21.8906V6.04688C9.55 5.71172 9.83688 5.4375 10.1875 5.4375H20.8125C21.1631 5.4375 21.45 5.71172 21.45 6.04688V21.8906Z",
    fill: "#2464EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1972_6487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 26,
    fill: "white",
    transform: "translate(7 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessible);
export default __webpack_public_path__ + "static/media/Accessible.045f59d3bbee9cec9c070fd55b1c38ae.svg";
export { ForwardRef as ReactComponent };